module.exports = require("./../../_gen/starling/assets/SoundFactory");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/assets/SoundFactory.js
// module id = 156
// module chunks = 0